import React, { useEffect } from "react";
import "./Edit_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import classNames from "classnames";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAll,
  GetSingle,
  Update,
} from "../../../../../../../features/admin/internship/internship/Slice";
import { IDS } from "../../../../../../../utils/IDS";
import {
  allDocument,
  allRequirement,
} from "../../../../../../../features/admin/common/Slice";

function Edit_offcanvas({ show, handleClose, setSuccess, setShowRejectModal }) {
  const dispatch = useDispatch();

  const [modalSuccessShow, setModalSuccessShow] = React.useState(false);

  const internshipDocument = useSelector((state) => state.common.all_document);
  const internshipRequirement = useSelector(
    (state) => state.common.all_requirement,
  );

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const accomodationStatus = watch("accomodation_status");
  const startDate = watch("start_date");
  const today = new Date().toISOString().split("T")[0];

  // Dynamic contacts
  const { fields: contactFields, append, remove } = useFieldArray({
    control,
    name: "contacts",
  });

  // Watch files for preview
  const logoFile = watch("logo");
  const imageFile = watch("image");
  const countryLogoFile = watch("country_logo");

  useEffect(() => {
    dispatch(allDocument());
    dispatch(allRequirement());
  }, [dispatch]);

  // Fetch and prefill data when offcanvas opens
  useEffect(() => {
    if (show) {
      const fetchData = async () => {
        const res = await dispatch(GetSingle(show));
        if (res?.payload?.data) {
          const d = res.payload.data;

          // Prefill main fields
          reset({
            name: d.name || "",
            title: d.title || "",
            description: d.description || "",
            address: d.address || "",
            stipend: d.stipend || "",

            start_date: d.start_date || "",
            end_date: d.end_date || "",
            work_hour: d.work_hour || "",
            vacancy: d.vacancy || "",

            accomodation_status: d.accomodation_status ? "true" : "false",
            meal_provided: d.meal_provided ? "true" : "false",
            uniform_provided: d.uniform_provided ? "true" : "false",
            laundry_service: d.laundry_service ? "true" : "false",

            street: d.street || "",
            postal_code: d.postal_code || "",
            city: d.city || "",
            country: d.country || "",

            requirements: internshipRequirement.filter((opt) =>
              d.requirement_ids?.includes(String(opt.value)),
            ),
            documents: internshipDocument.filter((opt) =>
              d.document_ids?.includes(String(opt.value)),
            ),

            contacts:
              d.contacts?.map((c) => ({
                name: c.name || "",
                email: c.email || "",
                contact_no: c.contact_no || "",
                designation: c.position || "",
              })) || [],
          });

          // Set file previews (existing images)
          setValue("existing_logo", d.logo);
          setValue("existing_image", d.image);
          setValue("existing_country_logo", d.country_logo);
        }
      };

      fetchData();
    }
  }, [
    show,
    dispatch,
    internshipRequirement,
    internshipDocument,
    reset,
    setValue,
  ]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      // Basic fields
      sendData.append("name", data.name?.trim() || "");
      sendData.append("title", data.title?.trim() || "");
      sendData.append("description", data.description?.trim() || "");
      sendData.append("address", data.address?.trim() || "");
      sendData.append("stipend", data.stipend || "");
      sendData.append("start_date", data.start_date || "");
      sendData.append("end_date", data.end_date || "");
      sendData.append("work_hour", data.work_hour || "");
      sendData.append("vacancy", data.vacancy || 0);

      sendData.append(
        "accomodation_status",
        data.accomodation_status === "true",
      );
      sendData.append("meal_provided", data.meal_provided === "true");
      sendData.append("uniform_provided", data.uniform_provided === "true");
      sendData.append("laundry_service", data.laundry_service === "true");

      // Conditional accommodation address
      if (data.accomodation_status === "true") {
        sendData.append("street", data.street?.trim() || "");
        sendData.append("postal_code", data.postal_code?.trim() || "");
        sendData.append("city", data.city?.trim() || "");
        sendData.append("country", data.country?.trim() || "");
      }

      // Files (only if new file selected)
      if (data.logo?.[0]) sendData.append("logo", data.logo[0]);
      if (data.image?.[0]) sendData.append("image", data.image[0]);
      if (data.country_logo?.[0])
        sendData.append("country_logo", data.country_logo[0]);

      // Multi-select arrays
      if (data.requirements) {
        data.requirements.forEach((item) =>
          sendData.append("requirement_ids[]", item.value),
        );
      }
      if (data.documents) {
        data.documents.forEach((item) =>
          sendData.append("document_ids[]", item.value),
        );
      }

      // Contacts
      if (data.contacts && data.contacts.length > 0) {
        data.contacts.forEach((contact, index) => {
          sendData.append(`contacts[${index}][name]`, contact.name || "");
          sendData.append(`contacts[${index}][email]`, contact.email || "");
          sendData.append(
            `contacts[${index}][contact_no]`,
            contact.contact_no || "",
          );
          sendData.append(
            `contacts[${index}][position]`,
            contact.designation || "",
          );
        });
      }

      const res = await dispatch(Update({ id: show, data: sendData }));

      if (res.meta.requestStatus === "fulfilled") {
        dispatch(GetAll());
        setModalSuccessShow(true); // open success modal
      } else {
        setShowRejectModal(true);
      }
    } catch (error) {
      console.error(error);
      setShowRejectModal(true);
    }
  };

  useEffect(() => {
    if (modalSuccessShow) {
      const timer = setTimeout(() => {
        setModalSuccessShow(false);
        handleClose(); // close offcanvas
        setSuccess(true); // parent success
      }, 3000); // ⏱️ 3 seconds

      return () => clearTimeout(timer);
    }
  }, [modalSuccessShow, handleClose, setSuccess]);

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit Internship</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Name, Title, Description, Address */}
                <div className="col-md-4 mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("name", { required: "Name is required" })}
                    className={classNames({ "is-invalid": errors.name })}
                  />
                  {errors.name && (
                    <Form.Text className="text-danger">
                      {errors.name.message}
                    </Form.Text>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("title", { required: "Title is required" })}
                    className={classNames({ "is-invalid": errors.title })}
                  />
                  {errors.title && (
                    <Form.Text className="text-danger">
                      {errors.title.message}
                    </Form.Text>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    {...register("description", {
                      required: "Description is required",
                    })}
                  />
                  {errors.description && (
                    <Form.Text className="text-danger">
                      {errors.description.message}
                    </Form.Text>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Label>General Address</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("address", {
                      required: "Address is required",
                    })}
                  />
                  {errors.address && (
                    <Form.Text className="text-danger">
                      {errors.address.message}
                    </Form.Text>
                  )}
                </div>

                <div className="col-md-4 mb-3"></div>

                <div className="col-md-4 mb-3"></div>

                {/* File Uploads with Preview */}
                <div className="col-md-4 mb-3">
                  <Form.Label>Logo</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    {...register("logo")}
                  />
                  {(logoFile?.[0] || watch("existing_logo")) && (
                    <img
                      src={
                        logoFile?.[0]
                          ? URL.createObjectURL(logoFile[0])
                          : IDS.IMG_URL + watch("existing_logo")
                      }
                      alt="Logo"
                      style={{
                        width: "100px",
                        height: "100px",
                        marginTop: "10px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Label>Image</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    {...register("image")}
                  />
                  {(imageFile?.[0] || watch("existing_image")) && (
                    <img
                      src={
                        imageFile?.[0]
                          ? URL.createObjectURL(imageFile[0])
                          : IDS.IMG_URL + watch("existing_image")
                      }
                      alt="Image"
                      style={{
                        width: "100px",
                        height: "100px",
                        marginTop: "10px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Label>Country Logo</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    {...register("country_logo")}
                  />
                  {(countryLogoFile?.[0] || watch("existing_country_logo")) && (
                    <img
                      src={
                        countryLogoFile?.[0]
                          ? URL.createObjectURL(countryLogoFile[0])
                          : IDS.IMG_URL + watch("existing_country_logo")
                      }
                      alt="Country Logo"
                      style={{
                        width: "100px",
                        height: "100px",
                        marginTop: "10px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </div>

                {/* Accommodation Status */}
                <div className="col-md-4 mb-3">
                  <Form.Label>Accommodation Available</Form.Label>
                  <div className="d-flex gap-4">
                    <Form.Check
                      type="radio"
                      label="Yes"
                      value="true"
                      {...register("accomodation_status", { required: true })}
                    />
                    <Form.Check
                      type="radio"
                      label="No"
                      value="false"
                      {...register("accomodation_status")}
                    />
                  </div>
                </div>

                {/* Conditional Address Fields */}
                {accomodationStatus === "true" && (
                  <>
                    <div className="col-md-4 mb-3">
                      <Form.Label>Street</Form.Label>
                      <Form.Control type="text" {...register("street")} />
                    </div>
                    <div className="col-md-4 mb-3">
                      <Form.Label>Postal Code</Form.Label>
                      <Form.Control type="text" {...register("postal_code")} />
                    </div>
                    <div className="col-md-4 mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Control type="text" {...register("city")} />
                    </div>
                    <div className="col-md-4 mb-3">
                      <Form.Label>Country</Form.Label>
                      <Form.Control type="text" {...register("country")} />
                    </div>
                  </>
                )}

                {/* Boolean Fields */}
                {["meal_provided", "uniform_provided", "laundry_service"].map(
                  (field) => (
                    <div className="col-md-4 mb-3" key={field}>
                      <Form.Label>
                        {field.replace(/_/g, " ").toUpperCase()}
                      </Form.Label>
                      <div className="d-flex gap-4">
                        <Form.Check
                          type="radio"
                          label="Yes"
                          value="true"
                          {...register(field)}
                        />
                        <Form.Check
                          type="radio"
                          label="No"
                          value="false"
                          {...register(field)}
                        />
                      </div>
                    </div>
                  ),
                )}

                {/* Stipend */}
                <div className="col-md-4 mb-3">
                  <Form.Label>Stipend</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    {...register("stipend", {
                      required: "Stipend is required",
                    })}
                  />
                  {errors.stipend && (
                    <Form.Text className="text-danger">
                      {errors.stipend.message}
                    </Form.Text>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    min={today}
                    {...register("start_date", {
                      required: "Start date is required",
                      validate: (value) =>
                        value >= today || "Start date cannot be in the past",
                    })}
                  />
                  {errors.start_date && (
                    <Form.Text className="text-danger">
                      {errors.start_date.message}
                    </Form.Text>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    min={startDate || today}
                    {...register("end_date", {
                      required: "End date is required",
                      validate: (value) =>
                        !startDate || value >= startDate
                          ? true
                          : "End date cannot be before start date",
                    })}
                  />
                  {errors.end_date && (
                    <Form.Text className="text-danger">
                      {errors.end_date.message}
                    </Form.Text>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Label>Work Hour (per day)</Form.Label>
                  <Form.Control
                    type="time"
                    {...register("work_hour", {
                      required: "Work hour is required",
                    })}
                  />
                  {errors.work_hour && (
                    <Form.Text className="text-danger">
                      {errors.work_hour.message}
                    </Form.Text>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Label>Vacancy</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    {...register("vacancy", {
                      required: "Vacancy is required",
                      min: { value: 1, message: "Vacancy must be at least 1" },
                    })}
                  />
                  {errors.vacancy && (
                    <Form.Text className="text-danger">
                      {errors.vacancy.message}
                    </Form.Text>
                  )}
                </div>

                {/* Requirements & Documents */}
                <div className="col-md-6 mb-3">
                  <Form.Label>Requirements</Form.Label>
                  <Controller
                    name="requirements"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isMulti
                        options={internshipRequirement}
                      />
                    )}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <Form.Label>Documents Required</Form.Label>
                  <Controller
                    name="documents"
                    control={control}
                    render={({ field }) => (
                      <Select {...field} isMulti options={internshipDocument} />
                    )}
                  />
                </div>

                {/* Dynamic Contacts */}
                <div className="col-12 mb-4">
                  <Form.Label className="fw-bold">Contact Persons</Form.Label>
                  {contactFields.map((field, index) => (
                    <div
                      key={field.id}
                      className="row align-items-end mb-3 border p-3 rounded bg-light"
                    >
                      <div className="col-md-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          {...register(`contacts.${index}.name`, {
                            required: true,
                          })}
                        />
                      </div>
                      <div className="col-md-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          {...register(`contacts.${index}.email`, {
                            required: true,
                          })}
                        />
                      </div>
                      <div className="col-md-2">
                        <Form.Label>Contact No</Form.Label>
                        <Form.Control
                          type="text"
                          {...register(`contacts.${index}.contact_no`, {
                            required: true,
                          })}
                        />
                      </div>
                      <div className="col-md-3">
                        <Form.Label>Designation</Form.Label>
                        <Form.Control
                          type="text"
                          {...register(`contacts.${index}.designation`, {
                            required: true,
                          })}
                        />
                      </div>
                      <div className="col-md-1">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </Button>
                      </div>
                    </div>
                  ))}
                  <Button
                    variant="blue_border_button btn btn-primary ms-2"
                    onClick={() =>
                      append({
                        name: "",
                        email: "",
                        contact_no: "",
                        designation: "",
                      })
                    }
                  >
                    + Add Contact
                  </Button>
                </div>
              </div>

              <div className="btn_holder mt-4 text-end">
                <Blue_border_button
                  button_text="Update Internship"
                  type="submit"
                />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalSuccessShow(false)}
        message_text="Internship updated successfully!"
        animationData={successAnimation}
      />
    </>
  );
}

export default Edit_offcanvas;
